import { QueryError } from "../../../../../microservices/functions/src/product_catalog/event_listeners/application_response";
import {
  CategoryDetailResult,
  FilteredCatalogResult,
  FilterQuery,
  InitialCatalogResult,
  ProductsCatalogResult,
  RequestPagination,
} from "../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { PaginationData } from "../types";

const getPaginationFilter = (
  pagination: PaginationData
): RequestPagination => ({
  offset: (pagination.currentPage - 1) * pagination.perPage,
  size: pagination.perPage,
});

export const fetchInitial = async (
  baseUrl: string,
  filter: FilterQuery,
  pagination: PaginationData
): Promise<InitialCatalogResult> => {
  const result = await fetch(`${baseUrl}/category/filter/initial`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ...filter,
      pagination: getPaginationFilter(pagination),
    }),
  });

  if (!result.ok) {
    throw await createHandledError(result);
  }

  return await result.json();
};

export const fetchProductsAndCounts = async (
  baseUrl: string,
  filter: FilterQuery,
  pagination: PaginationData
): Promise<FilteredCatalogResult> => {
  const result = await fetch(`${baseUrl}/category/filter/products-and-counts`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ...filter,
      pagination: getPaginationFilter(pagination),
    }),
  });

  if (!result.ok) {
    throw await createHandledError(result);
  }

  return await result.json();
};

export const fetchProducts = async (
  baseUrl: string,
  filter: FilterQuery,
  pagination: PaginationData
): Promise<ProductsCatalogResult> => {
  const result = await fetch(`${baseUrl}/category/filter/products`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ...filter,
      pagination: getPaginationFilter(pagination),
    }),
  });

  if (!result.ok) {
    throw await createHandledError(result);
  }

  return await result.json();
};

export const fetchCategoryDetail = async (
  baseUrl: string,
  categoryId: number
): Promise<CategoryDetailResult | QueryError> => {
  const result = await fetch(`${baseUrl}/category/${categoryId}`, {
    method: "GET",
  });

  if (!result.ok) {
    throw await createHandledError(result);
  }

  return await result.json();
};

const createHandledError = async (response: Response): Promise<QueryError> => {
  const errorBody = await extractErrorBody(response);
  const error = new Error(errorBody?.error ?? "Unknown error");
  (error as any)["details"] = errorBody;
  return (error as any) as QueryError;
};

const extractErrorBody = async (response: Response) => {
  try {
    return await response.json();
  } catch {
    return await response.text();
  }
};
